import { Field, useField } from 'formik'
import Styles from '../ReviewTemplateForm.module.scss'
import { ProseInput } from 'common/ProseInput/ProseInput'

interface Props {
  isDisabled: boolean
}

export const RichTextMessage = ({ isDisabled }: Props) => {
  const [htmlDescriptionField, , htmlDescriptionFieldHelpers] = useField('html_description')
  const [, , plainTextDescriptionFieldHelpers] = useField('description')

  const handleChange = (html: string, plainText: string) => {
    htmlDescriptionFieldHelpers.setValue(html)
    plainTextDescriptionFieldHelpers.setValue(plainText)
  }

  return (
    <>
      <label className={Styles.label} htmlFor="description">
        Message
      </label>
      <ProseInput
        placeholder="Type your message here..."
        className={Styles.message}
        initialHtmlString={htmlDescriptionField.value}
        onChange={handleChange}
        aria-label="Message"
      />
    </>
  )
}

export const Message = ({ isDisabled }: Props) => (
  <>
    <label className={Styles.label} htmlFor="description">
      Message
    </label>
    <Field
      as="textarea"
      className={Styles.message}
      name="description"
      id="description"
      placeholder="Type your message here..."
      disabled={isDisabled}
      aria-label="Message"
    />
  </>
)
